/**
 * Runs a function immediately and preserves its return type
 * Works with both sync and async functions
 * Supports passing arguments to the function
 *
 * Note: For type inference to work inside fn, either:
 * 1. Explicitly type the function parameters: inlineFn((x: number) => x + 1, 5)
 * 2. Or use a typed function reference: inlineFn(myFunction, arg1, arg2)
 */
export const inlineFn = <Args extends any[], R>(
	fn: (...args: Args) => R,
	...args: Args
): R => fn(...args);
